// Libraries
import React, { memo } from 'react';
import PropTypes from 'prop-types';

// Enums
import { EngagementReportType } from 'engagementReport/enums/propTypes';

// Helpers
import { renderMarkdown } from 'common/utils/helpers';

// Components
import EngagementReportSection from 'engagementReport/components/base/EngagementReportSection';
import EngagementReportSidebar from 'engagementReport/components/base/EngagementReportSidebar';

const EngagementReport = ({ engagementReport, projectStatus, projectHubEnabled }) => {
  const {
    introduction,
    conclusion,
    sections,
    engagement: { defaultLanguage },
  } = engagementReport.snapshot;
  const sectionsToRender = sections.filter((section) => section.questions.length);

  return (
    <div className="engagement-report">
      <div className="container inner">
        <div className="columns">
          <div className="column">
            {introduction && (
              <div className="engagement-report__introduction">
                <h2 className="title is-5 is-primary-color">Introduction</h2>
                <div
                  className="markdown"
                  dangerouslySetInnerHTML={{ __html: renderMarkdown(introduction) }}
                />
              </div>
            )}

            {sectionsToRender.map((section) => (
              <EngagementReportSection
                section={section}
                key={section.position}
                defaultLanguage={defaultLanguage}
              />
            ))}

            {conclusion && (
              <div className="engagement-report__conclusion">
                <h2 className="title is-5 is-primary-color">Conclusion</h2>
                <div
                  className="markdown"
                  dangerouslySetInnerHTML={{ __html: renderMarkdown(conclusion) }}
                />
              </div>
            )}
          </div>
          <div className="column is-one-quarter is-hidden-mobile">
            <EngagementReportSidebar
              engagementReport={engagementReport}
              projectStatus={projectStatus}
              projectHubEnabled={projectHubEnabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

EngagementReport.propTypes = {
  engagementReport: EngagementReportType.isRequired,
  projectStatus: PropTypes.string,
  projectHubEnabled: PropTypes.bool.isRequired,
};

EngagementReport.defaultProps = {
  projectStatus: '',
};

export default memo(EngagementReport);
